<!--
* @Author : ShaJiaJing
* @Date :  2019/5/30
* @Version : 1.0
* @Content : 仪表盘
-->
<template>
  <div class="dashboard">
    <a-row type="flex" class="line1" :gutter="24">
      <a-col :xxl="18" :xs="24">
        <!--机器人运行实况-->
        <line1-left></line1-left>
      </a-col>
      <a-col :xxl="6" :xs="24">
        <!--设计器状态-->
        <line1-right :data="line1RightData"></line1-right>
      </a-col>
    </a-row>
    <!--数据列表-->
    <line2 class="line2"></line2>
    <!--任务时间趋势-->
    <!--失败趋势-->
    <line3></line3>
  </div>
</template>

<script>
import { getRobAndTaskInfo, getRobAndTaskBaseInfo } from '@api/dashboard'
import line1Left from './components/line1Left'
import line1Right from './components/line1Right'
import line2 from './components/line2'
import line3 from './components/line3'

export default {
  components: { line2, line1Right, line1Left, line3 },
  data () {
    return {
      line2Data: {},
      line1RightData: {}
    }
  },
  created () {
    this.getRobAndTaskBaseInfo()
  },
  mounted () {
  },
  methods: {
    async getRobAndTaskInfo () {
      const res = await getRobAndTaskInfo()
      Object.assign(this.line2Data, res)
    },
    getRobAndTaskBaseInfo () {
      getRobAndTaskBaseInfo()
        .then(result => {
          this.line1RightData = result
        })
      // this.line1RightData = res
    }
  }
}
</script>

<style lang="less" scoped>
.dashboard {
  background: transparent;
}
</style>
